export const iconFontAwesomeGamingGamepad = (
	<i className="fa-solid fa-gamepad"></i>
);
